import { render, staticRenderFns } from "./spaces_list.vue?vue&type=template&id=3a63bdbc&scoped=true&lang=pug&"
import script from "./spaces_list.vue?vue&type=script&lang=js&"
export * from "./spaces_list.vue?vue&type=script&lang=js&"
import style0 from "./spaces_list.vue?vue&type=style&index=0&id=3a63bdbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a63bdbc",
  null
  
)

export default component.exports